module.exports = __webpack_public_path__ + "img/motor_no32.b6236b02.jpg";